/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export const AccountPlanType = {
    FREE: 'FREE',
    PAID_BASIC: 'PAID_BASIC',
    CUSTOM_TENANT: 'CUSTOM_TENANT'
} as const;
export type AccountPlanType = typeof AccountPlanType[keyof typeof AccountPlanType];

